import React from 'react';
import TaskActionIcon, { TaskActionIconType } from 'models/onboarding/process/action/TaskActionIcon';
import images from 'assets/images';

export type CalendarActionTileIconProps = { icon?: TaskActionIcon | string | null };

export const CalendarActionTileIcon = ({ icon }: CalendarActionTileIconProps) => {
	if (!icon) {
		return null;
	}

	const url =
		typeof icon === 'string'
			? icon
			: icon.type === TaskActionIconType.STATIC
			? images.portal.sectionIcons[icon.value as keyof typeof images.portal.sectionIcons]
			: icon.value;

	return (
		<div
			className="tile__image mx-auto mb-3 mb-sm-4 rounded-circle background-image size--cover"
			style={{
				backgroundImage: `url(${url})`,
			}}
		/>
	);
};
